import { all } from "redux-saga/effects";
import { watchFetchAuthAction } from "./authSaga.ts";

function* rootSaga() {
  yield all([
    // Saga Watchers
    watchFetchAuthAction(),
  ]);
}

export default rootSaga;
